import { ExternalCalendar } from '@griply/types';
import { useMemo } from 'react';

export type UseExternalConnectionCalendarsResult = {
  calendars: ExternalCalendar[];
  isLoading: boolean;
};

export const useExternalConnectionCalendars = (
  data: ExternalCalendar[] | undefined,
  isLoading: boolean,
): UseExternalConnectionCalendarsResult => {
  const calendars = useMemo(() => data ?? [], [data]);

  return { calendars, isLoading };
};
